import { BusinessCentres, Role } from '@cambridgeassessment/lib-ee-commons';

export const SET_USER_SELECTED_ROLE = '@USER_DATA/SET_USER_SELECTED_ROLE';
export const SET_BUSINESS_UNIT = '@USER_DATA/SET_BUSINESS_UNIT';
export const SET_AVAILABLE_BUSINESS_UNITS = '@USER_DATA/SET_AVAILABLE_BUSINESS_UNITS';

export interface SetUserSelectedRole {
  type: typeof SET_USER_SELECTED_ROLE;
  payload: Role;
}

export interface SetBusinessUnit {
  type: typeof SET_BUSINESS_UNIT;
  payload: {
    businessUnit: BusinessCentres;
  };
}

export interface SetAvailableBusinessUnits {
  type: typeof SET_AVAILABLE_BUSINESS_UNITS;
  payload: {
    businessUnits: BusinessCentres[];
  };
}

export type UserDataActionTypes = SetUserSelectedRole | SetBusinessUnit | SetAvailableBusinessUnits;
